import React from "react";

// Global safety net: turns any uncaught render exception into a simple recovery screen
// instead of a blank white page. Never exposes stack traces, tokens or financial data.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface during dev/test so failures are not silently swallowed; no external telemetry.
    if (process.env.NODE_ENV !== "production") console.error("App render error:", error, info);
  }

  handleHome = () => {
    this.setState({ error: null });
    if (typeof window !== "undefined") window.location.assign("/");
  };

  render() {
    if (this.state.error) {
      return (
        <div className="df-shell df-safe-top flex flex-col items-center justify-center min-h-screen px-8 text-center" data-testid="error-boundary">
          <div className="font-heading font-bold text-lg text-slate-900 mb-2">Something went wrong</div>
          <p className="text-sm text-slate-500 mb-6 max-w-xs">This screen hit an unexpected error. Your saved data is safe on this device.</p>
          <button onClick={this.handleHome} data-testid="error-boundary-home"
            className="h-11 px-6 rounded-xl bg-[#0D786A] hover:bg-[#0A6055] text-white font-medium df-pressable">
            Back to Home
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
